<div class="container-fluid p-0 privacy-policy" (contextmenu)="onRightClick($event)">
    <mat-card class="card mb-3 profile-common-card-container privacy">
        <mat-tab-group class="col-12">
            <mat-tab label="{{'termsandConditions'| translate}}">
                <div class="d-flex privacy-icon align-items-center mt-2 mb-3" *ngIf="consentValueCheck?.termsAcceptedDate">
                    <i class="material-icons mr-2">
                        check_circle_outline
                    </i>
                    <span>{{'Accepted-on'|translate}} {{consentValueCheck?.termsAcceptedDate | date:'medium'}}</span>

                </div>
                <div class="col-12 mt-3" [innerHTML]="termsData">
                </div>
            </mat-tab>
            <mat-tab label="{{'privacyNotice'| translate}}">
                <div class="d-flex privacy-icon align-items-center my-2" *ngIf="consentValueCheck?.privacyAcceptedDate">
                    <i class="material-icons mr-2">
                        check_circle_outline
                    </i>
                    <span>{{'Accepted-on'|translate}} {{consentValueCheck?.privacyAcceptedDate | date:'medium'}}</span>

                </div>
                <div class="col-12 mt-3" [innerHTML]="privacyData">
                </div>
            </mat-tab>

        </mat-tab-group>
    </mat-card>
</div>